// React provider for the shared QueryClient.
// See react-rewrite-plan.md sections 6.3 and 11.4 query-provider.
//
// The provider lazy-creates a module-level singleton so the app and tests
// share the same client across React reconciliations. Callers that need
// isolation (e.g. parallel tests) can pass their own client via `client`.

import { type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { getSingletonClient } from './singleton';

export interface QueryProviderProps {
  client?: QueryClient;
  children: ReactNode;
}

export function QueryProvider({ client, children }: QueryProviderProps) {
  const active = client ?? getSingletonClient();
  return <QueryClientProvider client={active}>{children}</QueryClientProvider>;
}
